// extracted by mini-css-extract-plugin
export default {"wrapper":"Item_wrapper__ZzXKM"};